import React from "react";
import { Field } from "../Fields";
import UserPicker from "../UserPicker";

/** Wspólny wybór izby i operatora; zmiana izby wymaga ponownego wskazania operatora. */
export default function CompanyIssuanceFields({
  config,
  chambers,
  token,
  disabled,
  onChange,
}) {
  return (
    <section className="card premium-panel" aria-label="Wystawianie i podpis">
      <h2>Wystawianie i podpis</h2>
      <div className="premium-grid">
        <Field
          label="Izba wystawiająca"
          required
          value={config.chamberId}
          onChange={(event) =>
            onChange({ chamberId: event.target.value, operatorId: "" })
          }
        >
          <option value="">Wybierz izbę</option>
          {chambers.map((item) => (
            <option key={item.id} value={item.id}>
              {item.name}
            </option>
          ))}
        </Field>
        <UserPicker
          key={config.chamberId}
          token={token}
          label="Operator podpisujący"
          operators
          chamberId={config.chamberId}
          value={config.operatorId}
          disabled={disabled}
          onChange={(event) => onChange({ operatorId: event.target.value })}
        />
      </div>
    </section>
  );
}
